import React from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import styles from './InfoBox.module.css';
export var Status;
(function (Status) {
    Status["Warning"] = "warning";
    Status["Success"] = "success";
    Status["Error"] = "error";
    Status["Info"] = "info";
    Status["Neutral"] = "neutral";
})(Status || (Status = {}));
const InfoBox = ({ className, status, icon, headlineText, children }) => (React.createElement("div", { className: cx(styles.infoBox, styles[status], className) },
    React.createElement(Text, { className: styles.title, size: TextSize.M, color: "neutral-100", bold: true },
        icon && (React.createElement("i", { className: cx(styles.iconWrap, styles[`${status}Icon`]) }, icon)),
        headlineText),
    children && (React.createElement(Text, { className: styles.description, size: TextSize.XS, color: "neutral-100", "data-testid": "InfoBoxDescription" }, children))));
export default InfoBox;
//# sourceMappingURL=InfoBox.js.map